import * as Yup from 'yup'

export const InviteTeamMemberSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Please enter a valid email address'),
})
